import { Module } from "vuex";

export interface SaveCountriesState {
  countries: string[];
}

const saveCountries: Module<SaveCountriesState, any> = {
  namespaced: true,
  state: {
    // load from localStorage safely
    countries: (() => {
      try {
        return JSON.parse(localStorage.getItem("countries") || "[]");
      } catch {
        return [];
      }
    })(),
  },
  mutations: {
    setCountries(state, list: string[]) {
      state.countries = list;
      localStorage.setItem("countries", JSON.stringify(list));
    },
  },
  actions: {
    updateCountries({ commit }, list: string[]) {
      commit("setCountries", list);
    },
  },
  getters: {
    getCountries: (state) => state.countries,
  },
};

export default saveCountries;
